import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavInnerToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import React, { useEffect, useState } from 'react';
import GlobalParams from './helpers/GlobalParams';
import LoadPanel from 'devextreme-react/load-panel';
import RoutesWithSessionStorage from './CustomRoute';

export default function Content() {

  //TODO-fetch params..
  const [isLoaded, setIsLoaded] = useState(false);
  const [navigateToPage, setNavigateToPage] = useState('/home');

  useEffect(() => {
    //check if session storage has lastVisitedRoute
    // const lastVisitedRoute = sessionStorage.getItem('lastVisitedRoute');
    // console.log("last visited route: " + lastVisitedRoute);
    // // Navigate to the last visited route if it exists
    // if (lastVisitedRoute) {
    //   setNavigateToPage(lastVisitedRoute);
    // } else {
    //   setNavigateToPage('/home');
    // }

    setNavigateToPage('/home');
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      fetchParams();
    } catch (error) {
      // Handle error, e.g., show an error message
      console.error(error);
    }
  }
  const fetchParams = async () => {

    await GlobalParams.fetchParams({
      param: 'scheme-riders',
      property: 'AllRiders',
    });

    //fetch schemes for the logged in person.....

    await GlobalParams.fetchParams({
      param: 'contact-allowed-person-schemes?contact_person_id=' + GlobalParams.ContactPersonId,
      property: 'schemeStore',
    });

    if (GlobalParams.schemeStore.length === 1) {
      GlobalParams.defaultSchemeId = GlobalParams.schemeStore[0]["schemeID"];

      // //schemeCategoriesStore
      // await GlobalParams.fetchParams({
      //   param: 'scheme-categories?scheme_id=' + GlobalParams.defaultSchemeId,
      //   property: 'schemeCategoriesStore',
      // });
    }

    await GlobalParams.fetchParams({
      param: 'product-classes',
      property: 'ProductClasses',
    });

    GlobalParams.QuoteProductClasses = GlobalParams.ProductClasses.filter
      (glclass => (
        (
          glclass.ShowInPortal === "1") &&
        glclass.IsActive === "1"
      )
      );

    await GlobalParams.fetchParams({
      param: 'product-rider-classes',
      property: 'ProductRider',
    });

    await GlobalParams.fetchParams({
      param: 'product-packages-classes',
      property: 'ProductPackages',
    });

    await GlobalParams.fetchParams({
      param: 'uw-decisions',
      property: 'MedicalUwDecision',
    });
    await GlobalParams.fetchParams({
      param: 'get-predefined-subjects',
      property: 'EnquiriesSubjects',
    });

    // await GlobalParams.fetchParams({
    //   param: 'occupation-classes',
    //   property: 'OccupationClasses',
    // });
    await GlobalParams.fetchParams({
      param: 'identity-types',
      property: 'IdentityTypes',
    });
    // await GlobalParams.fetchParams({
    //   param: 'nature-of-business',
    //   property: 'NatureOfBusiness',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'access-types',
    //   property: 'AccessTypes',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'political-status',
    //   property: 'PoliticalStatus',
    // });


    // await GlobalParams.fetchParams({
    //   param: 'claim-types',
    //   property: 'ClaimTpyes',
    // });

    // await GlobalParams.fetchParams({
    //   param: 'claim-causes',
    //   property: 'ClaimCauses',
    // });

    //
    // await GlobalParams.fetchParams({
    //   param: 'get-banks',
    //   property: 'Banks',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'get-payment-methods',
    //   property: 'PaymentMethods',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'get-bank-branches-codes',
    //   property: 'BankBranches',
    // });


    // await GlobalParams.fetchParams({
    //   param: 'get-statuses',
    //   property: 'StatusesStore',
    // });

    // await GlobalParams.fetchParams({
    //   param: 'esg-status',
    //   property: 'ESGStatus',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'ufaa-dormancy-status',
    //   property: 'UFAADormancyStatus',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'slams-preset-countries',
    //   property: 'Countries',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'counties',
    //   property: 'Counties',
    // });

    await GlobalParams.fetchParams({
      param: 'claim-types',
      property: 'ClaimTpyes',
    });  
    await GlobalParams.fetchParams({
      param: 'claim-causes',
      property: 'ClaimCauses',
    });
    await GlobalParams.fetchParams({
      param: 'get-payment-methods',
      property: 'PaymentMethods',
    });
    await GlobalParams.fetchParams({
      param: 'get-banks',
      property: 'Banks',
    });
    await GlobalParams.fetchParams({
      param: 'get-loan-types',
      property: 'LoanTypes',
    });
    await GlobalParams.fetchParams({
      param: 'get-bank-branches-codes',
      property: 'BankBranches',
    });
    await GlobalParams.fetchParams({
      param: 'get-statuses',
      property: 'StatusesStore',
    });


    setIsLoaded(true);
  }

  if (!isLoaded) {
    return <LoadPanel visible={true} />;
  }

  const generateRoutes = (routes) => {
    return routes.map(({ path, element }) => (
      <Route key={path} path={path} element={element} />
    ));
  };

  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {
          routes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={element}
            />
          ))}
        <Route
          path='*'
          element={<Navigate to={navigateToPage} />}
        />
      </Routes>
      <Footer>
        Copyright © {new Date().getFullYear()} {'SoftClans Technologies Limited'}.
        <br />
        All trademarks or registered trademarks are property of their
        respective owners.
      </Footer>
    </SideNavBarLayout>
  );
}